var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"marquee",on:{"mouseover":function($event){_vm.speedFactor = 1},"mouseleave":function($event){_vm.speedFactor = 1}}},[_c('div',{ref:"content",staticClass:"content",style:(_vm.translateX)},[_vm._v(" "+_vm._s(_vm.playText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }